// src/config.js

// const BASE_URL = 'http://127.0.0.1:8000';
const BASE_URL = 'https://bimanager.nexteck.uk';
export default BASE_URL;